var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.alternative)?_c('div',{staticClass:"text-block",domProps:{"innerHTML":_vm._s(_vm.content)}}):_c('div',{staticClass:"text-block alternative",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36ff63bb","hasScoped":false,"transformToRequire":{"video":"src","source":["src","srcset"],"vector":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/text-block/text.block.vue
// module id = ZJtL
// module chunks = 1